// Password reset email of the website logins (#857).
//
// One place for the call every login of the site makes
// (handlePasswordReset_piattaforma, origin 'website'): header, /iLogin,
// Vendi and the login popups send the same email, with the same brand and
// the same messages.
import { httpsCallable } from "firebase/functions";
import { functions } from "@/firebase/init.js";
import { currentBrand, pageBrand } from "@/globalStore.js";

export const PASSWORD_RESET_SENT = "Ti abbiamo inviato un'email per reimpostare la password.";
export const PASSWORD_RESET_FAILED = "Invio non riuscito. Riprova tra qualche minuto.";
export const PASSWORD_RESET_INVALID_EMAIL = "Controlla l'indirizzo email.";
export const PASSWORD_RESET_EMAIL_MISSING = "Inserisci l'email per recuperare la password.";

// The brand of the page the visitor is on, as everywhere else on the site.
export function passwordResetBrand() {
  return pageBrand() || currentBrand();
}

// The message for the callable's { status } answer (newarc-cloud-functions
// legacyAuth passwordResetMailCore): 200 sent (also when no account has that
// email: the answer never tells), 400 the email is not valid, anything else
// (429 too many requests, 500 send failed) a retry later.
export function passwordResetMessage(status) {
  if (status == 200) return PASSWORD_RESET_SENT;
  if (status == 400) return PASSWORD_RESET_INVALID_EMAIL;
  return PASSWORD_RESET_FAILED;
}

// Sends the reset email. Never throws: { ok, message } with the message to
// show, a failed call included.
export async function sendPasswordResetEmail(email, brand = passwordResetBrand()) {
  try {
    const send = httpsCallable(functions, "handlePasswordReset_piattaforma");
    const result = await send({
      email: String(email || "").trim(),
      templateId: 8097000,
      origin: "website",
      brand: brand || passwordResetBrand(),
      subject: "Reimposta la tua password",
      mailTitle: "Reimposta la tua password",
      mailBody: "Clicca sul pulsante qui sotto per reimpostare la tua password.",
      buttonText: "Reimposta password",
    });
    const status = result && result.data && result.data.status;
    return { ok: status == 200, message: passwordResetMessage(status) };
  } catch (e) {
    return { ok: false, message: PASSWORD_RESET_FAILED };
  }
}
